export default ({ store, redirect }) => {
  if (store.state.accessToken) {
    redirect('/registerCodes')
  }
}
